import { useLogout } from '@privy-io/react-auth';
import { useWallets } from '@privy-io/react-auth/solana';
import { notify } from 'src/utils/notifications';
import { useCallback } from 'react';
import useWalletContext from '../useWalletContext';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';

export const useDisconnectWallets = () => {
	const { wallets } = useWallets();
	const walletContext = useWalletContext();
	const walletAdapter = useDriftStore((s) => s.wallet.current.adapter); // Ideally, walletContext and walletAdapter should be the same. Added this because AppKit isn't link to WalletContext

	const { logout } = useLogout();

	/**
	 * Disconnects from all Privy connected wallets and the Solana Wallet Adapter, and logs out from Privy.
	 */
	const disconnectWallets = useCallback(async () => {
		const toastID = 'wallet_disconnection';
		notify({
			type: 'awaiting',
			message: 'Disconnecting wallet',
			id: toastID,
		});

		const walletDisconnectsPromises = wallets.map((wallet) =>
			wallet.disconnect()
		);

		await Promise.all([
			...walletDisconnectsPromises,
			// technically, the wallets disconnect by Privy should disconnect the external wallets too.
			// However, specifically for Phantom it doesn't disconnect properly, hence we use call the
			// solana wallet adapter's disconnect to ensure it disconnects properly
			walletContext.disconnect(),
			walletAdapter?.disconnect(),
			logout(),
		]);
	}, [wallets, logout, walletContext.disconnect, walletAdapter]);

	return disconnectWallets;
};
